/* eslint-disable max-len */
G.featureUnlock = { // The rest of the settings are at other-match3-engine\js\Config\featureUnlockDefault.js
  useNoGates: true,
  extraCoinsPerMove: {
    enabled: true,
  },
  useWebGLRenderer: true,
  tournamentPromo: true,
  friendshipChest: { // Friendship chest
    enabled: true,
    storyMode: true, // Have normal friendship chest or story mode
  },
  requestMoveHelp: true,
  gameTriggeredMessages: { // Activates game-triggered bot messages
    botMessages: true,
  },
  transactionTracking: {
    track: { // Activates "high-value" transaction event tracking
      ss: false, // player inventory snapshots
      rm: true, // real-money transactions
      inv: false, // inventory transactions
      crmInv: false, // CRM inventory transactions, should always be false for now
    },
    purge: { // Determines whether the game should transaction histories
      ss: true,
      rm: false,
      inv: true,
      crmInv: false, // should always be false for now
    },
  },
  eventPostcard: {
    enabled: false,
    range: {
      start: 1586304000000, // Apr 8, 2020 00:00:00 UTC
      end: 1587600000000, // Apr 23, 2020 00:00:00 UTC
    },
  },
  fortuneCookie: {
    enabled: true,
    dropChance: 20, // The base drop chance (%) of a fortune piece
    movesLeft: 15, // Piece drops at > movesLeft
    dismissLimit: 3, // The number of times you can dismiss the fortune cookie before cooldown
    activeDays: [5, 6, 0], // Active days are Fri, Sat, Sun, UTC
    resetDay: 1, // The day (Mon) dismiss is reset
  },
  achievementGifts: false,

  realMoneyPrizeWheel: true,
  realMoneyHelperWheel: true,
  realMoneyTargetedOfferWheel: true,

  unlockLevels: {
    coinDouble: 40,
  },
  freePrizeWheelSpin: true,
  freeFailFlowWheelSpin: false,
  multipleExtraMovesFailFlow: true,
  // limit the number of times a wheel can be spun. Settings are in json/settings(IAP).js
  limitSpins: {
    prizeWheel: false,
    lossAversionWheel: false,
  },
  weeklyTournament: { // weekly tournament settings
    enabled: true,
    ftuBotOptIn: true,
    ftuTutorial: true,
    ftuStartInGameState: true,
  },
  dailyChallenge: { // daily challenge settings
    enabled: true,
  },
  brag2: {
    enabled: false,
  },
  gateAlgorithm: 'conservative', // Algorithm for gate unlocking,
  villains: true, // Setting this to false disables super hard levels, window villain speech bubbles, tutorials and corruption
  delayedBoardAppereance: true, // Set this to enable delayed board appereance for hard levels.
  multiplePreLevelBoosters: true, // Set this to allow for multiple pre level boosters on hard and super hard levels.
  multipleBoosterBuyingPanel: {
    enabled: false,
    multiAndOne: false,
  },
  additionalInterstitialRules: {
    initial: true, // Toggles addition interstitial display rules. This is the initial implementaton. Includes EveryN, Out of Moves, Win 2 in a row, Give up
    tournamentWin: {
      enabled: true,
    },
    giftAds: {
      enabled: true,
    },
  },
  treasureHunt: { // Treasure Hunt super, now active on certain days!
    enabled: true,
  },
};
